(function () {
  let mine;
  let enabled = false;

  window.WishlistQueen = window.WishlistQueen || { loaded: false, mine: {}, busy: false };

  // set up button loader
  const wishlistButtonBlock = document.querySelector('wishlist-button-block');
  if (wishlistButtonBlock) {
    window.TitusRevive.addScriptToHead({ src: window.theme.scripts.wishlistButtonLoader });
    window.TitusRevive.addStyleToHead({ src: window.theme.styles.wishlistButtonLoaderStyle });
  }

  // get session id from cookies or local storage
  const cookie = document.cookie.split('; ').reduce((aggr, cur) => { aggr[cur.split('=')[0]] = cur.split('=')[1]; return aggr; }, {}).wk_session_id;
  const wk_session_id = localStorage.getItem("wk_session_id") || cookie;

  // fetch wishlist
  wishlistFetch();

  function enableButton() {
    if (enabled) return;
    enabled = true;

    const button = document.querySelectorAll("a.wk-button");
    if (button.length === 0) return;

    button.forEach((b) => {
      b.href = "/apps/wishlist";
      b.classList.remove("wk-disabled");
      updateButton(b);
    });
  }

  function updateButton(b) {
    if (mine) {
      const counter = b.querySelector(".wk-counter");
      if (mine.numItems) {
        counter.textContent = mine.numItems;
        counter.style.opacity = 1;
      }
    }
  }

  function getAppmateSrc () {
    const me = [
      {
        pageType: "product",
        match: (i) => i.includes("/products/"),
      },
      {
        pageType: "collection",
        match: (i) => i.includes("/collections/") && !i.includes("/products/"),
      },
      {
        pageType: "account",
        match: (i) => i.includes("/account/") || i.endsWith("/account"),
      },
      {
        pageType: "challenge",
        match: (i) => i.endsWith("/account"),
      },
      {
        pageType: "blog",
        match: (i) => i.includes("/blog/"),
      },
      {
        pageType: "cart",
        match: (i) => i.includes("/cart/") || i.endsWith("/cart"),
      },
      {
        pageType: "wishlist",
        match: (i) => i.includes("/apps/wishlist"),
      },
      {
        pageType: "page",
        match: (i) => i.includes("/pages/"),
      },
      {
        pageType: "search",
        match: (i) => i.includes("/search"),
      },
      {
        pageType: "home",
        match: (i) => i.length < 4,
      },
    ];

    const url = window.location.pathname;
    const match = me.find((i) => i.match(url));
    return match ? match.pageType : "unknown";
  }

  function wishlistFetch() {
    if (!wk_session_id && (!window.meta || !window.meta.page.customerId)) {
      enableButton();
      window.theme.data.wishlist.mine = null;
      document.dispatchEvent(new CustomEvent("wk-wishlist-loaded", { detail: null }));
      window.theme.data.wishlist.loaded = true;
      return;
    }

    fetch("https://api.appmate.io/v2/wishlists/mine", {
      headers: {
        "sec-fetch-dest": "empty",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "cross-site",
        "x-appmate-shp": "862e0b.myshopify.com",
        "x-appmate-cid": window.meta ? window.meta.page.customerId : undefined,
        "x-appmate-sid": wk_session_id,
        "x-appmate-src": getAppmateSrc(),
      },
      referrer: "https://www.titus-shop.com/",
      referrerPolicy: "strict-origin-when-cross-origin",
      body: null,
      method: "GET",
      mode: "cors",
      credentials: "omit",
    }).then((res) =>
      res.json().then((data) => {
        mine = data.wishlist;
        window.theme.data.wishlist.mine = mine;
        document.dispatchEvent(new CustomEvent("wk-wishlist-loaded", { detail: mine }));
        window.theme.data.wishlist.loaded = true;
      })
    ).finally(() => {
      window.WishlistQueen.loaded = true;
      enableButton();
    });
  }
})();
